import React, {useEffect} from 'react';
import AppContainer from './AppContainer';
import ReactGA from "react-ga4";

const AppWrapper = (props) => {

  useEffect(() => {
    ReactGA.initialize("G-1FZVDTNZVH");
    console.log("App initialized with analytics.");
  }, [])

  return (
    <AppContainer />
  );
}

export default AppWrapper;